import { render } from "./JobsMain.vue?vue&type=template&id=03966ecb&scoped=true"
import script from "./JobsMain.vue?vue&type=script&lang=js"
export * from "./JobsMain.vue?vue&type=script&lang=js"

import "./JobsMain.vue?vue&type=style&index=0&id=03966ecb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03966ecb"]])

export default __exports__